var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-vendor-terms-of-service"},[_c('edit',{attrs:{"fs":_vm.termsOfServiceFields,"api":"settings","id":"vendor-terms-of-service","title":"Vendor Terms of Service"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }